import { render, staticRenderFns } from "./PageSubtitle.vue?vue&type=template&id=2ed50219&scoped=true&"
import script from "./PageSubtitle.vue?vue&type=script&lang=js&"
export * from "./PageSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./PageSubtitle.vue?vue&type=style&index=0&id=2ed50219&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed50219",
  null
  
)

export default component.exports